export { ScreenInGamePage } from './screen';
